import { render, staticRenderFns } from "./HotfanShopList.vue?vue&type=template&id=d235f692&scoped=true"
import script from "./HotfanShopList.vue?vue&type=script&lang=js"
export * from "./HotfanShopList.vue?vue&type=script&lang=js"
import style0 from "./HotfanShopList.vue?vue&type=style&index=0&id=d235f692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d235f692",
  null
  
)

export default component.exports